import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SadieSimulatorThread } from "@/types";

// Sadie answers on her own time, so the thread is read again this often
// while she might.
const POLL_INTERVAL_MS = 1_500;

export const sadieSimulatorThreadQueryKey = (talentId: number | null) =>
  ["sadie-simulator-thread", talentId] as const;

// Polls while the tester is in the simulator, and while `isStarting`, since
// the opener goes out before the start call returns.
export function useGetSadieSimulatorThread(
  talentId: number | null,
  isStarting: boolean,
) {
  return useQuery({
    queryKey: sadieSimulatorThreadQueryKey(talentId),
    queryFn: async () => {
      const res = await guacHttpClient.get<
        SadieSimulatorThread,
        HttpResponse<SadieSimulatorThread>
      >("relationships/simulator/thread", { params: { talentId } });
      return res.data;
    },
    enabled: talentId !== null,
    refetchInterval: (query) =>
      isStarting || query.state.data?.simulator ? POLL_INTERVAL_MS : false,
  });
}
